// Apolo IDE — GuardBanner (ui, sprint composer-anchor E3).
//
// Banner pré-envio mostrado SÓ quando há conflito de alvo (pref ≠ origin da
// pasta). Poka-yoke: o envio fica bloqueado e o usuário resolve com botões
// NOMEADOS (NN/g — nunca "OK/Cancelar"). Apresentacional: os handlers vivem no
// CodeComposer (limpar pref vs aceitar a intenção).

import { AlertTriangle } from 'lucide-react';

/**
 * @param {{ context: import('../../lib/gitContext.js').GitContext, onUseDetected: () => void, onUseSelected: () => void }} props
 */
export default function GuardBanner({ context, onUseDetected, onUseSelected }) {
  if (!context || context.health !== 'conflict') return null;
  const selected = context.selectedSlug || 'o repo selecionado';
  const detected = context.origin || 'o repo da pasta';

  return (
    <div
      role="alert"
      className="rounded-lg border border-apolo-warning bg-apolo-warningBg px-3 py-2.5"
    >
      <div className="flex items-start gap-2.5">
        <AlertTriangle size={17} className="mt-0.5 shrink-0 text-apolo-warning" aria-hidden="true" />
        <div className="min-w-0 flex-1">
          <p className="text-[13px] font-medium text-apolo-warning">
            O repo selecionado não bate com a pasta da sessão
          </p>
          <p className="mt-0.5 text-[12px] leading-relaxed text-apolo-warning">
            Pref: <code className="font-mono">{selected}</code> · a pasta já tem origin{' '}
            <code className="font-mono">{detected}</code>. Qual o agente deve usar?
          </p>
          <div className="mt-2.5 flex flex-wrap gap-2">
            <button
              type="button"
              onClick={onUseSelected}
              className="inline-flex h-7 items-center rounded-md border border-apolo-borderStrong bg-apolo-surface1 px-2.5 text-[12px] text-apolo-textPrimary transition hover:bg-apolo-surface2"
            >
              Usar {selected} (clonar)
            </button>
            <button
              type="button"
              onClick={onUseDetected}
              className="inline-flex h-7 items-center rounded-md bg-apolo-textPrimary px-2.5 text-[12px] font-medium text-apolo-bg transition hover:opacity-90"
            >
              Usar {detected} detectado
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
